import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/sharedMutationTypes.ts'), 'sharedMutationTypes.ts')
  resolveStoreModules(require('../store/versions/index.js'), 'versions/index.js')
  resolveStoreModules(require('../store/vaccines/index.js'), 'vaccines/index.js')
  resolveStoreModules(require('../store/users/index.js'), 'users/index.js')
  resolveStoreModules(require('../store/telemetry/index.js'), 'telemetry/index.js')
  resolveStoreModules(require('../store/news/index.js'), 'news/index.js')
  resolveStoreModules(require('../store/issues/index.ts'), 'issues/index.ts')
  resolveStoreModules(require('../store/instances/index.js'), 'instances/index.js')
  resolveStoreModules(require('../store/dashboard/index.js'), 'dashboard/index.js')
  resolveStoreModules(require('../store/configs/index.js'), 'configs/index.js')
  resolveStoreModules(require('../store/computers/index.js'), 'computers/index.js')
  resolveStoreModules(require('../store/certs/index.js'), 'certs/index.js')
  resolveStoreModules(require('../store/authentication/index.js'), 'authentication/index.js')
  resolveStoreModules(require('../store/audit/index.js'), 'audit/index.js')
  resolveStoreModules(require('../store/application/index.ts'), 'application/index.ts')
  resolveStoreModules(require('../store/alerts/index.js'), 'alerts/index.js')
  resolveStoreModules(require('../store/agencies/index.js'), 'agencies/index.js')
  resolveStoreModules(require('../store/agencies/actions.js'), 'agencies/actions.js')
  resolveStoreModules(require('../store/agencies/getters.js'), 'agencies/getters.js')
  resolveStoreModules(require('../store/agencies/mutations.js'), 'agencies/mutations.js')
  resolveStoreModules(require('../store/agencies/state.js'), 'agencies/state.js')
  resolveStoreModules(require('../store/alerts/actions.js'), 'alerts/actions.js')
  resolveStoreModules(require('../store/alerts/alertMutationTypes.ts'), 'alerts/alertMutationTypes.ts')
  resolveStoreModules(require('../store/alerts/getters.js'), 'alerts/getters.js')
  resolveStoreModules(require('../store/alerts/mutations.js'), 'alerts/mutations.js')
  resolveStoreModules(require('../store/alerts/state.js'), 'alerts/state.js')
  resolveStoreModules(require('../store/audit/actions.js'), 'audit/actions.js')
  resolveStoreModules(require('../store/audit/getters.js'), 'audit/getters.js')
  resolveStoreModules(require('../store/audit/mutations.js'), 'audit/mutations.js')
  resolveStoreModules(require('../store/audit/state.js'), 'audit/state.js')
  resolveStoreModules(require('../store/certs/actions.js'), 'certs/actions.js')
  resolveStoreModules(require('../store/certs/getters.js'), 'certs/getters.js')
  resolveStoreModules(require('../store/certs/mutations.js'), 'certs/mutations.js')
  resolveStoreModules(require('../store/certs/state.js'), 'certs/state.js')
  resolveStoreModules(require('../store/computers/actions.js'), 'computers/actions.js')
  resolveStoreModules(require('../store/computers/getters.js'), 'computers/getters.js')
  resolveStoreModules(require('../store/computers/mutations.js'), 'computers/mutations.js')
  resolveStoreModules(require('../store/computers/state.js'), 'computers/state.js')
  resolveStoreModules(require('../store/configs/actions.js'), 'configs/actions.js')
  resolveStoreModules(require('../store/configs/getters.js'), 'configs/getters.js')
  resolveStoreModules(require('../store/configs/mutations.js'), 'configs/mutations.js')
  resolveStoreModules(require('../store/configs/state.js'), 'configs/state.js')
  resolveStoreModules(require('../store/dashboard/actions.js'), 'dashboard/actions.js')
  resolveStoreModules(require('../store/dashboard/getters.js'), 'dashboard/getters.js')
  resolveStoreModules(require('../store/dashboard/mutations.js'), 'dashboard/mutations.js')
  resolveStoreModules(require('../store/dashboard/state.js'), 'dashboard/state.js')
  resolveStoreModules(require('../store/instances/actions.js'), 'instances/actions.js')
  resolveStoreModules(require('../store/instances/getters.js'), 'instances/getters.js')
  resolveStoreModules(require('../store/instances/mutations.js'), 'instances/mutations.js')
  resolveStoreModules(require('../store/instances/state.js'), 'instances/state.js')
  resolveStoreModules(require('../store/issues/issuesMutationTypes.ts'), 'issues/issuesMutationTypes.ts')
  resolveStoreModules(require('../store/news/actions.js'), 'news/actions.js')
  resolveStoreModules(require('../store/news/getters.js'), 'news/getters.js')
  resolveStoreModules(require('../store/news/mutations.js'), 'news/mutations.js')
  resolveStoreModules(require('../store/news/state.js'), 'news/state.js')
  resolveStoreModules(require('../store/telemetry/actions.js'), 'telemetry/actions.js')
  resolveStoreModules(require('../store/telemetry/getters.js'), 'telemetry/getters.js')
  resolveStoreModules(require('../store/telemetry/mutations.js'), 'telemetry/mutations.js')
  resolveStoreModules(require('../store/telemetry/state.js'), 'telemetry/state.js')
  resolveStoreModules(require('../store/users/actions.js'), 'users/actions.js')
  resolveStoreModules(require('../store/users/getters.js'), 'users/getters.js')
  resolveStoreModules(require('../store/users/mutations.js'), 'users/mutations.js')
  resolveStoreModules(require('../store/users/state.js'), 'users/state.js')
  resolveStoreModules(require('../store/vaccines/actions.js'), 'vaccines/actions.js')
  resolveStoreModules(require('../store/vaccines/deploymentActions.js'), 'vaccines/deploymentActions.js')
  resolveStoreModules(require('../store/vaccines/getters.js'), 'vaccines/getters.js')
  resolveStoreModules(require('../store/vaccines/mutations.js'), 'vaccines/mutations.js')
  resolveStoreModules(require('../store/vaccines/state.js'), 'vaccines/state.js')
  resolveStoreModules(require('../store/versions/actions.js'), 'versions/actions.js')
  resolveStoreModules(require('../store/versions/getters.js'), 'versions/getters.js')
  resolveStoreModules(require('../store/versions/mutations.js'), 'versions/mutations.js')
  resolveStoreModules(require('../store/versions/state.js'), 'versions/state.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
